/* Kalanne : cases de packs (quantité) + bouton d'ajout au panier qui ouvre le tiroir. */
(function () {
  function init(root) {
    if (!root || root.dataset.klReady) return;
    root.dataset.klReady = '1';
    var packs = root.querySelectorAll('.kl-pdp__pack');
    var atc = root.querySelector('[data-kl-atc]');
    var atcPrice = root.querySelector('[data-kl-atc-price]');
    var price = root.querySelector('[data-kl-price]');
    var compare = root.querySelector('[data-kl-compare]');
    var errorBox = root.querySelector('.kl-pdp__error');

    function current() {
      var c = root.querySelector('.kl-pdp__pack input:checked');
      return c || root.querySelector('.kl-pdp__pack input');
    }
    function sync() {
      packs.forEach(function (p) {
        var input = p.querySelector('input');
        p.classList.toggle('is-selected', input.checked);
      });
      var c = current();
      if (!c) return;
      if (atcPrice && c.dataset.price) atcPrice.textContent = c.dataset.price;
      // Comme Tystrap : le prix du haut ne bouge pas, seul le prix du bouton suit le pack.
    }
    packs.forEach(function (p) {
      p.querySelector('input').addEventListener('change', sync);
    });
    sync();

    if (!atc) return;
    atc.addEventListener('click', function () {
      var c = current();
      var qty = c ? parseInt(c.value, 10) || 1 : 1;
      var scope = root.closest('product-info, .product') || root;
      var variantInput = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
      var variantId = (variantInput && variantInput.value) || root.dataset.variantId;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: [{ id: Number(variantId), quantity: qty }] };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
      atc.classList.add('is-loading');
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (errorBox) { errorBox.textContent = res.description || res.message; errorBox.hidden = false; }
            return;
          }
          if (!cart) { window.location = window.routes ? window.routes.cart_url : '/cart'; return; }
          // Même forme de réponse que le formulaire natif de Dawn (1er article + sections).
          var state = Object.assign({}, res.items && res.items[0] ? res.items[0] : {}, { sections: res.sections });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kl-pdp', productVariantId: variantId, cartData: state });
          }
          cart.classList.remove('is-empty');
          cart.renderContents(state);
          if (cart.tagName === 'CART-DRAWER' && typeof cart.open === 'function' && !cart.classList.contains('active')) cart.open();
        })
        .catch(function (e) { console.error(e); })
        .finally(function () { atc.classList.remove('is-loading'); });
    });
  }
  function initGallery(g) {
    if (!g || g.dataset.klReady) return;
    g.dataset.klReady = '1';
    var track = g.querySelector('[data-kl-track]');
    var thumbs = g.querySelectorAll('.kl-gallery__thumb');
    function select(i) {
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-selected', i === j);
        if (i === j) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var t = thumbs[i], bar = t && t.parentElement;
      if (t && bar && bar.scrollWidth > bar.clientWidth) {
        var l = t.offsetLeft - bar.offsetLeft, r = l + t.offsetWidth;
        if (l < bar.scrollLeft || r > bar.scrollLeft + bar.clientWidth) bar.scrollTo({ left: l - 24, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: track.children[i].offsetLeft - track.children[0].offsetLeft, behavior: 'smooth' });
        select(i);
      });
    });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var w = track.children[0] ? track.children[0].offsetWidth : 1;
        select(Math.round(track.scrollLeft / w));
      }, 80);
    }, { passive: true });
  }
  // Barre collante (comme Tystrap / Focal) : visible quand le haut du bouton principal est sorti par le haut de l'écran,
  // cachée quand le pied de page arrive. Ordi : collée sous l'en-tête collant. Téléphone : bouton en bas.
  function initSticky(root) {
    var bar = root.querySelector('[data-kl-sticky]');
    var atc = root.querySelector('[data-kl-atc]');
    if (!bar || !atc || bar.dataset.klReady) return;
    bar.dataset.klReady = '1';
    document.body.appendChild(bar);
    var footer = document.querySelector('.footer, footer, .shopify-section-group-footer-group');
    function headerBottom() {
      // Bas de l'en-tête visible collé en haut de l'écran (0 s'il est caché).
      var b = 0;
      document.querySelectorAll('.kl-header, header, sticky-header, .header-wrapper, .section-header').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.top <= 1 && r.bottom > b && r.bottom < 300) b = r.bottom;
      });
      return Math.max(0, Math.round(b));
    }
    var ticking = false;
    function update() {
      ticking = false;
      var show = atc.getBoundingClientRect().top < 0;
      // Téléphone seulement : cachée quand le pied de page arrive (sur ordi, Tystrap la garde jusqu'en bas).
      if (show && window.innerWidth < 750 && footer && footer.getBoundingClientRect().top < window.innerHeight) show = false;
      if (window.innerWidth >= 750) bar.style.top = headerBottom() + 'px';
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelector('button').tabIndex = show ? 0 : -1;
    }
    var settle;
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
      // L'en-tête du thème se cache / revient avec une animation : on recale la barre après.
      clearTimeout(settle); settle = setTimeout(update, 320);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    bar.querySelector('[data-kl-sticky-btn]').addEventListener('click', function () { atc.click(); });
    update();
  }
  function boot() { document.querySelectorAll('.kl-pdp').forEach(function (r) { init(r); initSticky(r); }); document.querySelectorAll('[data-kl-gallery]').forEach(initGallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
